export const catalogFunctions = {
  getScore,
};

function getScore(min, max, param, value = null) {
  if (null === value) {
    if (param === 'draftProtection') {
      return (min[param] * 1.5 - min[param]) * 100 / (min[param] * 1.5 - max[param]);
    }

    return min[param] * 100 / max[param];
  }

  if (param === 'draftProtection') {
    return (min[param] * 1.5 - value) * 100 / (min[param] * 1.5 - max[param]);
  }

  return value * 100 / max[param];
}